
import {AccentService} from "../AccentService/AccentService";

// ToDo: String.substr je depreciated ale nejde proste nahradit za String.substring protoze druhy argument je jiny.
//      Do budoucna by bylo dobre prepsat a napsat automaticke testy.
//      Konkretne rozdil je v tom ze:
//          String.substr(start, length)
//          String.substring(indexStart, indexEnd)
/**
 * Prekopiraovana funkce z legacy kodu pro zvyrazneni vyshledavaneho string ve stringu.
 *        Napriklad:
 *            $pattern = 'ri', $text = 'Bedřichov' => 'Bed<strong>ři</strong>chov'
 */
export function boldSearchPatterInString(accentService: AccentService, pattern: string, text: string): string {
    let text_dia = accentService.normalize(text);
    pattern = accentService.normalize(pattern);
    pattern = pattern.toLowerCase();
    text_dia = text_dia.toLowerCase();
    let pattern_length = pattern.length;
    let pozice = 0;
    let offset_text = 0;
    while (text_dia.indexOf(pattern, pozice) !== -1) {
        pozice = text_dia.indexOf(pattern, pozice);
        let pozice_text = pozice + offset_text;
        let pattern_text = text.substr(pozice_text, pattern_length);
        let re = new RegExp('('+pattern_text+')', 'i') ;
        let sub_text = text.substr(pozice_text);
        text = text.substr(0,pozice_text) + sub_text.replace(re,"<strong>$1</strong>");
        pozice = pozice + pattern_length;
        offset_text += 17;
    }

    return text;
}